/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb



import '../scss/application.scss'

import 'jquery-ui/themes/base/core.css'
import 'jquery-ui/themes/base/dialog.css'
import 'jquery-ui/themes/base/theme.css'
import 'jquery-ui/themes/base/tooltip.css'
import $ from 'jquery'
window.$ = window.jQuery = $;

// Remove once we delete the xml page.
import CodeMirror from 'codemirror'
window.CodeMirror = CodeMirror;


import dialog from 'jquery-ui/ui/widgets/dialog'  // eslint-disable-line no-unused-vars
import {TestReports} from '../test_reports/index.js'
window.TestReports = TestReports;
import tooltip from 'jquery-ui/ui/widgets/tooltip' // eslint-disable-line no-unused-vars



